module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00059-fs8.c947890.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00059-fs8.png
// module id = 212
// module chunks = 0